/**
 * схема для настроект
 * @property {array} settingsItems - элементы настроект
 */
let schemeSettings = {
    settingsItems: [
        {
            id: 0,
            title: 'Справочник и алиасы',
            text: 'Настройка представления загружаемых данных из Excel',
            routeName: 'settingsAliases',
            isSettingsPermission: true
        },
        {
            id: 1,
            title: 'Логи',
            text: 'Просмотр логов валидации файлов',
            routeName: 'settingsLogs',
            isSettingsPermission: false
        },
        {
            id: 2,
            title: 'Клиенты Менеджеров',
            text: 'Редактирование списка клиентов и менеджеров',
            routeName: 'settingsUserClients',
            isSettingsPermission: false
        },
        {
            id: 3,
            title: 'Справочник клиентов',
            text: 'Редактирование списка клиентов',
            routeName: 'settingsClients',
            isSettingsPermission: true
        },
        {
            id: 4,
            title: 'Группхеды',
            text: 'Расшаривание аккаунтов менеджеров',
            routeName: 'settingsGroupHead',
            isSettingsPermission: true
        },
        {
            id: 5,
            title: 'Справочник брендов',
            text: 'Редактирование списка брендов',
            routeName: 'settingsBrands',
            isSettingsPermission: false
        },
        {
            id: 6,
            title: 'Управление срезами',
            text: 'Удаление срезов',
            routeName: 'settingsSlice',
            isSettingsPermission: false
        },
        {
            id: 7,
            title: 'История загрузок',
            text: 'Список загруженных файлов менеджерами',
            routeName: 'settingsHistory',
            isSettingsPermission: true
        },
        {
            id: 8,
            title: 'Ragic',
            text: 'Бюджеты для загрузки в раджик',
            routeName: 'settingsRagicBudget',
            isSettingsPermission: true
        },
        {
            id: 9,
            title: 'Chameleon Telegram Notify',
            text: 'Уведомления в Chameleon Telegram бота',
            routeName: 'settingsTelegramNotify',
            isSettingsPermission: false
        },
    ]
}

export default schemeSettings;